export const VERSION = "1.4.0";


//////////////////
// WEBPACK FOOTER
// ./~/axios/lib/env/data.js
// module id = 22
// module chunks = 0